import type { ClientOfferWithPlans, Pages } from '@avalara/types/offers';
import type { OfferState } from '@avalara/types/reducer-states';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: OfferState = {
  provisioningDelayed: false,
  analyticsProductCategory: '',
  attributionDefaults: {},
  fetchStatus: 'PENDING',
  includesSelectPage: false,
  isPaymentRequired: false,
  offerFlow: null,
  offerName: '',
  orderSummary: { totalText: '' },
  pages: [],
  plans: [],
  termsAndConditions: [],
  thankYouContent: {},
};

const store = createSlice({
  name: 'offer',
  initialState,
  reducers: {
    setCurrentOfferPage: (state, action: PayloadAction<Pages>) => {
      state.currentPage = action.payload;
    },
    setOffer: (state, action: PayloadAction<ClientOfferWithPlans | 'NOT_FOUND' | null>) =>
      action.payload && action.payload !== 'NOT_FOUND'
        ? { ...initialState, includesSelectPage: state.includesSelectPage, ...action.payload, fetchStatus: 'SUCCESS' }
        : { ...initialState, fetchStatus: 'NOT_FOUND' },
    setProvisioningDelayed: (state, action: PayloadAction<boolean>) => {
      state.provisioningDelayed = action.payload;
    },
  },
});

export const { setCurrentOfferPage, setOffer, setProvisioningDelayed } = store.actions;

export default store;
